import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'
import { type CreateGroupPostRequest } from '../types'

const ZCreateGroupApiResponse = z.object({
  asset_group_id: z.string(),
  group_name: z.string()
})

const ZApiResponse = z.object({
  http_status: z.number(),
  data: ZCreateGroupApiResponse,
  error: z.boolean()
})

export type CreateGroupApiResponse = z.infer<typeof ZCreateGroupApiResponse>
export type ApiResponse = z.infer<typeof ZApiResponse>

export async function createGroup (
  createGroupPostRequest: CreateGroupPostRequest,
  onSuccess: (successResponse: CreateGroupApiResponse, httpStatus: number) => any,
  onFailure: (errorMessage: string, httpStatus: number) => any
): Promise<void> {
  const url = '/asset-service/api/v1/udp/groupManagement/assetGroup'

  interceptedAxios
    .post(url, createGroupPostRequest)
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)
      // istanbul ignore else
      if (parseResponse.success) {
        onSuccess(parseResponse.data.data, parseResponse.data.http_status)
      } else {
        onFailure('Error occurred while processing response', response.status)
      }
    })
    .catch((error) => {
      // istanbul ignore else
      if (error.response !== undefined) {
        // istanbul ignore else
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.data.http_status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
